// extracted by mini-css-extract-plugin
export default {"table_container":"Table_table_container__Turem","table":"Table_table__YTxTN"};